import React, { useState } from 'react';
import Cookies from 'js-cookie';

const Login = () => {
    const [formData, setFormData] = useState({ username: '', password: '' });
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');

        try {
            const encodedData = new URLSearchParams();
            for (const [key, value] of Object.entries(formData)) {
                encodedData.append(key, value);
            }

            const res = await fetch('/api/api/auth/login', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: encodedData.toString(),
            });

            const data = await res.json();

            if (res.ok) {
                // Store token safely
                Cookies.set('authToken', data.access_token, { expires: 1 });

                setMessage('Login successful!');
                window.location.href = '/dashboard';
            } else {
                const errorMsg =
                    data.detail || data.message || data.error || 'Invalid username or password.';
                setMessage(errorMsg);
            }
        } catch (err) {
            console.error(err);
            setMessage('Network error. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#581745] to-[#3a0d2c]">
            <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-md">
                <h2 className="text-3xl font-bold text-center mb-6 text-[#581745]">
                    Welcome Back
                </h2>

                <form onSubmit={handleSubmit} className="space-y-5">
                    <div>
                        <label className="block text-gray-700 mb-1 font-medium">
                            Username
                        </label>
                        <input
                            type="text"
                            name="username"
                            value={formData.username}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#581745]"
                            placeholder="Enter your username"
                        />
                    </div>

                    <div>
                        <label className="block text-gray-700 mb-1 font-medium">
                            Password
                        </label>
                        <input
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#581745]"
                            placeholder="••••••••"
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full py-3 bg-[#581745] text-white font-semibold rounded-lg hover:bg-[#6b1c50] transition-colors"
                    >
                        {loading ? 'Logging in...' : 'Login'}
                    </button>
                </form>

                {message && (
                    <p className="text-center mt-4 text-sm font-medium text-gray-700">{message}</p>
                )}
            </div>
        </div>
    );
};

export default Login;
